const VERSION = '3.1.3';
export function getVersionString() {
    return VERSION;
}
